module.exports = __webpack_public_path__ + "static/designTmp-7452fb1bc80d0fdbb7e1bfd74b227875.png";